import { useV2Session } from './stores/session';

// Single prefix for the whole v2 experience. Promotion to the main app = set this to ''.
export const V2_BASE = '/v2';
export const v2Path = (path = '') => `${V2_BASE}${path}` || '/';

const DEFAULT_AFTER_LOGIN = v2Path('/tierlist');

export function safeNextPath(next) {
  if (typeof next !== 'string') return DEFAULT_AFTER_LOGIN;
  if (!next.startsWith(`${V2_BASE}/`) && next !== V2_BASE) return DEFAULT_AFTER_LOGIN;
  if (next.includes('//') || next.includes('\\')) return DEFAULT_AFTER_LOGIN;
  return next;
}

export async function v2Guard(to) {
  const session = useV2Session();
  if (!session.loaded) await session.fetchMe();
  if (to.meta.requiresUser && !session.isLoggedIn) {
    return { path: v2Path('/login'), query: { next: to.fullPath } };
  }
  if (to.meta.requiresAdmin && !session.isAdmin) {
    return { path: v2Path() };
  }
  return true;
}

export const v2Routes = [
  {
    path: V2_BASE || '/',
    component: () => import('./layout/V2Layout.vue'),
    meta: { v2: true },
    children: [
      { path: '', name: 'V2Home', component: () => import('./views/CurrentView.vue') },
      { path: 'login', name: 'V2Login', component: () => import('./views/LoginView.vue') },
      { path: 'help', name: 'V2Help', component: () => import('./views/HelpView.vue') },
      { path: 'tierlist', name: 'V2Tierlist', component: () => import('./views/TierlistView.vue') },
      { path: 'albums/:id', name: 'V2Album', component: () => import('./views/AlbumView.vue'), meta: { requiresUser: true } },
      { path: 'submit', name: 'V2Submit', component: () => import('./views/SubmitView.vue'), meta: { requiresUser: true } },
      { path: 'club', name: 'V2Club', component: () => import('./views/ClubView.vue'), meta: { requiresUser: true } },
      { path: 'members', name: 'V2Members', redirect: v2Path('/club') },
      { path: 'members/:id', name: 'V2Member', component: () => import('./views/MemberView.vue'), meta: { requiresUser: true } },
      { path: 'sessions', name: 'V2Sessions', component: () => import('./views/SessionsView.vue'), meta: { requiresUser: true } },
      { path: 'sessions/new', name: 'V2SessionNew', component: () => import('./views/SessionNewView.vue'), meta: { requiresUser: true } },
      { path: 'sessions/:id', name: 'V2Session', component: () => import('./views/SessionView.vue'), meta: { requiresUser: true } },
      { path: 'queue', name: 'V2Queue', component: () => import('./views/QueueView.vue'), meta: { requiresUser: true } },
      { path: 'activity', name: 'V2Activity', component: () => import('./views/ActivityView.vue'), meta: { requiresUser: true } },
      { path: 'notifications', name: 'V2Notifications', component: () => import('./views/NotificationsView.vue'), meta: { requiresUser: true } },
      { path: 'profile', name: 'V2Profile', component: () => import('./views/ProfileView.vue'), meta: { requiresUser: true } },
      { path: 'admin', name: 'V2Admin', component: () => import('./views/AdminView.vue'), meta: { requiresUser: true, requiresAdmin: true } },
    ],
  },
];
